import { View, Text, Styles } from 'primase';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faComment } from '@fortawesome/free-solid-svg-icons';
import { useFeatureFlags } from '../../helpers/hooks';
import { A } from '../link';

import supportStyles from './support-link.module.scss';

const styles = {
  wrapper: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    transform: 'translateY(-100%)',
    width: 1032,
    maxWidth: '100%',
    margin: '0 auto',
    padding: `0 ${Styles.spacing.sp2}px`,
    display: 'flex',
    alignItems: 'flex-end',
    pointerEvents: 'none',
  },
  link: {
    marginLeft: 'auto',
    maxWidth: 180,
  },
  button: {
    textAlign: 'center',
    padding: '6px 16px',
    backgroundColor: Styles.color.blue[700],
    color: Styles.color.neutral.white,
    fontSize: 16,
    fontWeight: 900,
    lineHeight: 20,
    borderRadius: '4px 4px 0 0',
    pointerEvents: 'auto !important',
  },
  linkWrapper: {
    [`@media screen and (max-width: ${Styles.layout.Breakpoints.xs}px)`]: {
      margin: '2px auto',
    },
  },
};

const MppSupportLink = () => {
  const { t } = useTranslation();

  return (
    <View css={styles.wrapper} data-testid="support-link__wrapper">
      <View inline css={styles.linkWrapper}>
        <A
          to={window.env.REACT_APP_GENESYS_CHAT_URL}
          target="_blank"
          rel="noopener"
          styles={styles.link}
          aria-label={t('labels.contactSupport')}
        >
          <View css={styles.button}>
            <Text>{t('labels.contactSupport')}</Text>
          </View>
        </A>
      </View>
    </View>
  );
};

const UppSupportLink = () => {
  const { t } = useTranslation();

  return (
    <div className={supportStyles.wrapper} data-testid="support-link__wrapper">
      <div className={supportStyles.linkWrapper}>
        <A
          to={window.env.REACT_APP_GENESYS_CHAT_URL}
          target="_blank"
          rel="noopener"
          aria-label={t('labels.contactSupport')}
        >
          <div className={supportStyles.button}>
            <div className={supportStyles.liveAgent}>
              <div className={supportStyles.text}>
                {t('labels.contactSupport')}
              </div>
              <FontAwesomeIcon
                icon={faComment}
                className={supportStyles.icon}
              />
            </div>
          </div>
        </A>
      </div>
    </div>
  );
};

const SupportLink = () => {
  const { uppConsultsEnabled } = useFeatureFlags();

  return uppConsultsEnabled ? <UppSupportLink /> : <MppSupportLink />;
};

export default SupportLink;
